




import { Component, Vue } from 'vue-property-decorator';
import MenuNav from '@/components/shared/MenuNav.vue'
import { IMenuItem } from '@/models/ui/IMenuItem';

@Component({
  name:'MenuAdministration',
  props:{
      hideTitle:{
        type:Boolean,
        default:false
      }
  },
  components: {    
    MenuNav,    
  },
})
export default class MenuAdministration extends Vue {
  hideTitle!:boolean

  get menuTitle(){
    return this.hideTitle?undefined:"Administration"
  }

  private get administrationItems(){
      return [
      {icon:'mdi-account-group',to:{name:'AdminContact'}, text:'Contacts'},
      {icon:'mdi-email',to:{name:'AdminNewsletter'}, text:'Newsletter'},
      {icon:'mdi-pool',to:{name:'AdminPiscine'}, text:'Piscines'},
      {icon:'mdi-waves',to:{name:'AdminActivity'}, text:'Activites'},
      //{icon:'mdi-web',to:{name:'AdminPage'}, text:'Pages'},
      //{icon:'mdi-folder-multiple-image',to:{name:'AdminMedia'}, text:'Médiathèque'},
      //{icon:'mdi-calendar-clock',to:{name:'AdminCours'}, text:'Cours'},
      //{icon:'mdi-account-child-outline',to:{name:'AdminMns'}, text:'MNS'},
      {icon:'mdi-currency-usd',to:{name:'AdminForfait'}, text:'Tarifs'},
      {icon:'mdi-account-multiple',to:{name:'AdminFamily'}, text:'Familles'},
      //{icon:'mdi-post',to:{name:'AdminArticle'}, text:'Articles Blog'},
      {icon:'mdi-cart',to:{name:'AdminCommande'}, text:'Commandes'},
      {icon:'mdi-brush',to:{name:'AdminMailSkin'}, text:this.$t('App.MailSkin')},
      {icon:'mdi-email-edit',to:{name:'AdminMailTemplate'}, text:this.$t('App.MailTemplate')},
    ] as Array<IMenuItem>
  }
}
